import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";

class Activities extends React.Component {

    render() {
        return (
            <LegacyFrame customFrameClass={'activity-container'} withHeader={true} pageTitle={"Activities"} formname={"planner"} customClass={"field-customization-container"} />
        );
    }
}

export default Activities;
